import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "doc-viewer" }
const _hoisted_2 = { class: "doc-viewer__inner" }
const _hoisted_3 = {
  key: 0,
  class: "document-notification-container"
}
const _hoisted_4 = { class: "document-notification" }
const _hoisted_5 = {
  key: 1,
  class: "document-notification-container error"
}
const _hoisted_6 = { class: "document-notification" }
const _hoisted_7 = {
  key: 3,
  class: "document-notification-container error"
}
const _hoisted_8 = { class: "document-notification" }
const _hoisted_9 = {
  key: 0,
  class: "doc-viewer__controls"
}
const _hoisted_10 = { class: "doc-viewer__pagination" }
const _hoisted_11 = { class: "zoom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_PdfDocument = _resolveComponent("PdfDocument")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showDocumentLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, { path: "documents.loading.title" })
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "documents.loading.description" })
              ]),
              _cache[0] || (_cache[0] = _createElementVNode("div", { class: "loader" }, null, -1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.errorDetail?.title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, {
                  path: _ctx.errorDetail.title
                }, null, 8, ["path"])
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, {
                  path: _ctx.errorDetail.description
                }, null, 8, ["path"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.src)
        ? (_openBlock(), _createBlock(_component_PdfDocument, {
            key: 2,
            src: _ctx.src,
            scale: _ctx.scale,
            onLoaded: _ctx.handlePdfLoaded,
            onRendered: _ctx.handleDocumentRendered,
            onError: _ctx.handleDocumentError
          }, null, 8, ["src", "scale", "onLoaded", "onRendered", "onError"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("h4", null, [
                _createVNode(_component_TranslatedText, { path: "documents.error.title" })
              ]),
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "documents.error.description" })
              ])
            ])
          ]))
    ]),
    (_ctx.documentRendered)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createVNode(_component_TranslatedText, { path: "documents.pages.total" }),
              _createTextVNode(" " + _toDisplayString(_ctx.pageCount), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, {
                class: "zoom__out",
                icon: "minus",
                onClick: _ctx.handleZoomOut
              }, null, 8, ["onClick"]),
              _createVNode(_component_font_awesome_icon, {
                class: "zoom__icon",
                icon: "search"
              }),
              _createVNode(_component_font_awesome_icon, {
                class: "zoom__in",
                icon: "plus",
                onClick: _ctx.handleZoomIn
              }, null, 8, ["onClick"])
            ])
          ]),
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}